// src/components/ProtectedRoute/ProtectedRouteABM.jsx
import { useUser } from "../../hooks/useUser";
import { useNavigate } from "react-router-dom";
import { Button, Container, Row, Col } from "react-bootstrap";

export const ProtectedRouteABM = ({ children, nivel }) => {
  const { user, loading } = useUser();
  const navigate = useNavigate();

  if (loading) return <div>Cargando...</div>;

  if (!user || user.nivelSuscripcion < nivel) {
    return (
      <Container className="py-5">
        <Row className="justify-content-center">
          <Col md={6} className="text-center">
            <h2>Acceso denegado</h2>
            <p>No tienes permisos para acceder a esta sección.</p>
            <Button variant="primary" onClick={() => navigate("/")}>Ir al Home</Button>
          </Col>
        </Row>
      </Container>
    );
  }

  return children;
};